export interface AppointmentConflictCandidate {
  id: string;
  assignedRep?: string | null;
  appointmentTime?: string | null;
}

const APPOINTMENT_MS = 2 * 60 * 60 * 1000;
const BUFFER_MS = 2 * 60 * 60 * 1000;
const BLOCKED_WINDOW_MS = APPOINTMENT_MS + BUFFER_MS;

function isWithinBlockedWindow(startA: Date, startB: Date): boolean {
  const aStart = startA.getTime();
  const aEnd = aStart + BLOCKED_WINDOW_MS;
  const bStart = startB.getTime();
  const bEnd = bStart + BLOCKED_WINDOW_MS;
  return aStart < bEnd && bStart < aEnd;
}

export function findRepAppointmentOverlap(
  items: AppointmentConflictCandidate[],
  params: {
    rep: string;
    candidateStartIso: string;
    excludeId?: string;
  },
): AppointmentConflictCandidate | null {
  const rep = String(params.rep ?? "").trim().toLowerCase();
  if (!rep || rep === "unassigned") return null;

  const candidateDate = new Date(params.candidateStartIso);
  if (Number.isNaN(candidateDate.getTime())) return null;

  for (const item of items) {
    if (!item) continue;
    if (params.excludeId && item.id === params.excludeId) continue;
    const itemRep = String(item.assignedRep ?? "").trim().toLowerCase();
    if (!itemRep || itemRep === "unassigned") continue;
    if (itemRep !== rep) continue;
    if (!item.appointmentTime) continue;

    const existingDate = new Date(item.appointmentTime);
    if (Number.isNaN(existingDate.getTime())) continue;
    if (isWithinBlockedWindow(existingDate, candidateDate)) return item;
  }

  return null;
}
